import React from 'react';
import { IConditionProps, IDataSource } from '@types';
import { Button, IconButton, Select } from 'uxp/components';
import './SourceMapper.scss';

interface SourceMapperProps {
    conditions: IConditionProps[],
    source1: IDataSource,
    source2: IDataSource;
    onChange: (conditions: IConditionProps[]) => void;
}

export const SourceMapper: React.FC<SourceMapperProps> = ({ conditions, source1, source2, onChange }) => {

    const updateCondition = (index: number, field: string, value: any) => {
        const newConditions = [...conditions];
        newConditions[index] = { ...newConditions[index], [field]: value };
        onChange(newConditions);
    };

    const addCondition = () => {
        const newConditions = [...conditions, { source1: '', source2: '' }];
        onChange(newConditions);
    };

    const removeCondition = (index: number) => {
        const newConditions = conditions.filter((_, i) => i !== index);
        onChange(newConditions);
    };

    return (
        <div className="lucy-query-engine-source-mapper">
            {
                (conditions || []).map((c, i) => (
                    <div key={i} className="lucy-query-engine-source-mapper-condition">
                        <div className="lucy-query-engine-source-mapper-condition-field">
                            <Select
                                selected={c.source1}
                                onChange={s => updateCondition(i, 'source1', s)}
                                options={(source1?.schema || []).map(f => ({ label: f.name, value: f.name }))}
                                placeholder='-- source 01 --'
                            />
                        </div>
                        <div className="lucy-query-engine-source-mapper-condition-field">
                            <Select
                                selected={c.source2}
                                onChange={s => updateCondition(i, 'source2', s)}
                                options={(source2?.schema || []).map(f => ({ label: f.name, value: f.name }))}
                                placeholder='-- source 02 --'
                            />
                        </div>
                        <IconButton type='delete' onClick={() => removeCondition(i)} size='small' />
                    </div>
                ))
            }

            <div className="lucy-query-engine-source-mapper-condition">
                <Button title='Add condition' onClick={addCondition} icon='fas plus' />
            </div>
        </div>
    );
};


export function validateConditions(conditions: IConditionProps[]): { isValid: boolean, error?: string, uniqueAttributesSource1?: string[], uniqueAttributesSource2?: string[] } {
    const uniqueAttributesSource1 = new Set<string>();
    const uniqueAttributesSource2 = new Set<string>();
    if (!conditions || conditions.length === 0) {
        return { isValid: false, error: "At least one condition is required", uniqueAttributesSource1: [], uniqueAttributesSource2: [] };
    }

    for (const condition of conditions) {
        if (!condition.source1 || !condition.source2) {
            return { isValid: false, error: "Each condition must have fields from both sources", uniqueAttributesSource1: [], uniqueAttributesSource2: [] };
        }
        uniqueAttributesSource1.add(condition.source1);
        uniqueAttributesSource2.add(condition.source2);
    }

    return { isValid: true, error: null, uniqueAttributesSource1: Array.from(uniqueAttributesSource1), uniqueAttributesSource2: Array.from(uniqueAttributesSource2) };
}